import styled from "@emotion/styled";
import {
    colors,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
} from "@gumtree/ui-library/src/base/theme";

export const StyledBodyItem = styled.div`
    font-weight: ${fontWeights.normal};
    font-size: ${fontSizes.base};
    line-height: ${lineHeights.base};
    color: ${colors.bark};
    margin-bottom: ${gutterSizes.medium10};

    .icon--small {
        font-size: ${fontSizes.header};
        margin-right: ${gutterSizes.medium10};
    }
`;
